import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { WheelPartItem } from "../../../queries/useSearchWheelsByVehicle";
import { Button } from "../../../ui/Button/Button";
import { useStockLevelsModal } from "../../Tires/Results/StockLevelsModal/StockLevelsModal";

type StockLevelsProps = {
  part: WheelPartItem;
};

export const StockLevels: FunctionComponent<StockLevelsProps> = ({ part }) => {
  const { t } = useTranslation();
  const [, setPartId] = useStockLevelsModal();
  return (
    <div className="px-4 md:px-8 text-sm text-ink-2 font-thin flex items-center">
      <span className="mr-auto">{t("searchResults.nationalStock")}:</span>
      <Button
        onClick={(): void => {
          setPartId(part.partDetails.primaryPart.itemId);
        }}
        aria-label="checkNationalStock"
        className="py-4 rounded-none"
      >
        {t("searchResults.checkNationalStock")}
      </Button>
    </div>
  );
};
